import React, { useEffect } from 'react';
import { Navigate } from 'react-router-dom';

import AuthService, { useAuthContext} from "../../../services/AuthService";

const Logout = ( props) => { 
    console.log("================================== Logout ======================================");

    // Get Auth Context
    const auth = useAuthContext();
    const { dispatch } = auth;

    useEffect(() => {
        AuthService.Logout().finally(() => {
            dispatch({ type: "LOGOUT" });
        });
    }, [dispatch]);

    return (
        <Navigate to="/" replace={true} />
        //<div>Logout</div>
    );
};
export default Logout;
